import { useState, useEffect } from 'react'

import { getProvincesAPI } from '../services/address'

function UseProvinces() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getProvincesAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.PROVINCE_ID, label: d.PROVINCE_NAME }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseProvinces
